import { JSEncrypt } from 'jsencrypt'
// 时间工具
export function dataFormat (originVal, separator) { // 后台传回来的S
  // Ie下的new Date只能接收2019/01/01 00：00：00或者是数字类型这两种格式
  // console.log('originVal:', originVal)
  if (!originVal) {
    return ''
  }
  if (originVal.replace) {
    originVal = originVal.replace(/-/g, '/')
  }
  // console.log('替换后的originVal：', originVal)
  const date = new Date(originVal)
  // console.log('date:', date)
  const y = date.getFullYear()
  let m = date.getMonth() + 1
  m = m < 10 ? '0' + m : m
  const d = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
  const h = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
  const f = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
  const s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
  const dateStr = separator
    ? (y + separator + m + separator + d + ' ' + h + ':' + f + ':' + s)
    : (y + '-' + m + '-' + d + ' ' + h + ':' + f + ':' + s)
  return dateStr
}
export const dateHelper = {
  // 当前的时间，获取最近一年的起始时间
  getRecentYear (type) {
    const beginTime = new Date()
    beginTime.setHours(0)
    beginTime.setMinutes(0)
    beginTime.setSeconds(0)
    const endTime = new Date()
    endTime.setHours(23)
    endTime.setMinutes(59)
    endTime.setSeconds(59)
    console.log(endTime.getMonth(), endTime.getDate())
    if ((endTime.getFullYear() % 4 === 0 && endTime.getFullYear() % 100 > 0) &&// 闰年
        endTime.getMonth() + '' === '1' && endTime.getDate() + '' === '29'// 2月分而且是29号
    ) {
      beginTime.setDate(28)
      // console.log('beginTime:', beginTime)
      beginTime.setFullYear(endTime.getFullYear() - 1)
    } else {
      beginTime.setFullYear(endTime.getFullYear() - 1)
    }
    // console.log([this.getDteStr(beginTime), this.getDteStr(endTime)])
    if (type === 'number') {
      return [beginTime, endTime]
    } else {
      return [this.getDteStr(beginTime), this.getDteStr(endTime)]
    }
  },
  // 获取最近一周时间
  getRecentWeek (type) {
    const endTime = new Date()
    const time = 3600 * 24 * 6 * 1000
    const beginTime = new Date(endTime.getTime() - time)
    beginTime.setHours(0)
    beginTime.setMinutes(0)
    beginTime.setSeconds(0)
    endTime.setHours(23)
    endTime.setMinutes(59)
    endTime.setSeconds(59)
    console.log(endTime.getMonth(), endTime.getDate())
    // console.log([this.getDteStr(beginTime), this.getDteStr(endTime)])
    if (type === 'number') {
      return [beginTime, endTime]
    } else {
      return [this.getDteStr(beginTime), this.getDteStr(endTime)]
    }
  },
  dayFormat (originVal, separator) { // 后台传回来的S
    const date = new Date(originVal)
    const y = date.getFullYear()
    let m = date.getMonth() + 1
    m = m < 10 ? '0' + m : m
    const dateStr = separator
      ? (y + separator + m)
      : (y + '-' + m)
    return dateStr
  },
  getDteStr (date, separator) {
    const y = date.getFullYear()
    let m = date.getMonth() + 1
    m = m < 10 ? '0' + m : m
    const d = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
    const h = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
    const f = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
    const s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
    const dateStr = separator
      ? (y + separator + m + separator + d + separator + h + ':' + f + ':' + s)
      : (y + '-' + m + '-' + d + ' ' + h + ':' + f + ':' + s)
    return dateStr
  }
}

// 打开下载链接下载文件
// export const loadFileByUrl = function (url) {
//   var tempwindow = window.open('_blank') // 先打开页面
//   tempwindow.location = url // 后更改页面地址
// }

export const loadFileByUrl = function (url, saveName) {
  // for ie 10 and later
  url = url.replace(/http:/g, 'https:')
  console.log('下载的url：', url)
  if (window.navigator.msSaveBlob) {
    try {
      window.navigator.msSaveBlob(url, saveName)
    } catch (e) {
      console.log(e)
    }
  } else {
    // 谷歌浏览器 创建a标签 添加download属性下载
    if (typeof url === 'object' && url instanceof Blob) {
      url = URL.createObjectURL(url) // 创建blob地址
    }
    var aLink = document.createElement('a')
    aLink.href = url
    aLink.download = saveName || '' // HTML5新增的属性，指定保存文件名，可以不要后缀，注意，file:///模式下不会生效
    var event
    if (window.MouseEvent) {
      event = new MouseEvent('click')
    } else {
      event = document.createEvent('MouseEvents')
      event.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null)
    }
    aLink.dispatchEvent(event)
  }
}
// export const redirectUrl = function (url) {
//   /\/api\//.test(url)
//     ? ''
//     : /device\/shadow/.test(url)
//       ? url = '/api/shadows-service' + url
//       : /dataAnalysis\/map/.test(url)
//         ? url = '/api/data-service' + url
//         : /\/manager\//.test(url)
//           ? url = '/api/safety-service' + url
//           : url = '/api' + url
//   return url
// }

/**
 * 此方法为复制内容到粘贴板
 * val 你要复制的额内容
 * callback为回调方法
 */
export function copy (val, callback) {
  const input = document.createElement('input') // 直接构建input
  input.value = val
  document.body.appendChild(input) // 添加临时实例
  input.select() // 选择实例内容
  document.execCommand('Copy') // 执行复制
  document.body.removeChild(input) // 删除临时实例
  callback()
}

/**
将blob数据下载成文件
*/
export function loadBlod2File (blob, filename) {
  var reader = new FileReader()
  reader.onload = function (e) {
    // 转换完成，创建一个a标签用于下载
    var a = document.createElement('a')
    a.download = filename || 'data.xlsx'
    a.href = e.target.result
    document.body.appendChild(a) // 修复firefox中无法触发click
    a.click()
    document.body.removeChild(a) // 删除临时实例
  }
  reader.readAsDataURL(blob) // 转换为base64，可以直接放入a表情href
}

/**
用于下载文件流时候截取返回头的filename文件名
*/
export function getDownloadFilename (str, key) {
  let filename = ''
  if (str) {
    const arr = str.split(';')
    for (let i = 0; i < arr.length; i++) {
      if (key) {
        if (arr[i].split('=')[0] === key) {
          filename = arr[i].split('=')[1]
          filename = filename.replace(/utf-8''/, '')
          filename = decodeURI(filename)
          break
        }
      } else if (arr[i].split('=')[0] === 'filename*') {
        filename = arr[i].split('=')[1]
        filename = filename.replace(/utf-8''/, '')
        filename = decodeURI(filename)
        break
      }
    }
  }
  return filename
}

/**
*UTF16和UTF8转换对照表
*U+00000000–U+0000007F 0xxxxxxx
*U+00000080–U+000007FF 110xxxxx10xxxxxx
*U+00000800–U+0000FFFF 1110xxxx10xxxxxx10xxxxxx
*U+00010000–U+001FFFFF 11110xxx10xxxxxx10xxxxxx10xxxxxx
*U+00200000–U+03FFFFFF 111110xx10xxxxxx10xxxxxx10xxxxxx10xxxxxx
*U+04000000–U+7FFFFFFF 1111110x10xxxxxx10xxxxxx10xxxxxx10xxxxxx10xxxxxx
*/
export const Base64 = {
  // 转码表
  table: [
    'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H',
    'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P',
    'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X',
    'Y', 'Z', 'a', 'b', 'c', 'd', 'e', 'f',
    'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n',
    'o', 'p', 'q', 'r', 's', 't', 'u', 'v',
    'w', 'x', 'y', 'z', '0', '1', '2', '3',
    '4', '5', '6', '7', '8', '9', '+', '/'
  ],
  UTF16ToUTF8: function (str) {
    const res = []; const len = str.length
    for (let i = 0; i < len; i++) {
      const code = str.charCodeAt(i)
      if (code > 0x0000 && code <= 0x007F) {
        // 单字节，这里并不考虑0x0000，因为它是空字节
        // U+00000000–U+0000007F 0xxxxxxx
        res.push(str.charAt(i))
      } else if (code >= 0x0080 && code <= 0x07FF) {
        // 双字节
        // U+00000080–U+000007FF 110xxxxx10xxxxxx
        // 110xxxxx
        const byte1 = 0xC0 | ((code >> 6) & 0x1F)
        // 10xxxxxx
        const byte2 = 0x80 | (code & 0x3F)
        res.push(
          String.fromCharCode(byte1),
          String.fromCharCode(byte2)
        )
      } else if (code >= 0x0800 && code <= 0xFFFF) {
        // 三字节
        // U+00000800–U+0000FFFF 1110xxxx10xxxxxx10xxxxxx
        // 1110xxxx
        const byte1 = 0xE0 | ((code >> 12) & 0x0F)
        // 10xxxxxx
        const byte2 = 0x80 | ((code >> 6) & 0x3F)
        // 10xxxxxx
        const byte3 = 0x80 | (code & 0x3F)
        res.push(
          String.fromCharCode(byte1),
          String.fromCharCode(byte2),
          String.fromCharCode(byte3)
        )
      } else if (code >= 0x00010000 && code <= 0x001FFFFF) {
        // 四字节
        // U+00010000–U+001FFFFF 11110xxx10xxxxxx10xxxxxx10xxxxxx
      } else if (code >= 0x00200000 && code <= 0x03FFFFFF) {
        // 五字节
        // U+00200000–U+03FFFFFF 111110xx10xxxxxx10xxxxxx10xxxxxx10xxxxxx
      } else /** if(code>=0x04000000&&code<=0x7FFFFFFF) */{
        // 六字节
        // U+04000000–U+7FFFFFFF 1111110x10xxxxxx10xxxxxx10xxxxxx10xxxxxx10xxxxxx
      }
    }

    return res.join('')
  },
  UTF8ToUTF16: function (str) {
    const res = []; const len = str.length
    for (let i = 0; i < len; i++) {
      const code = str.charCodeAt(i)
      // 对第一个字节进行判断
      if (((code >> 7) & 0xFF) === 0x0) {
        // 单字节
        // 0xxxxxxx
        res.push(str.charAt(i))
      } else if (((code >> 5) & 0xFF) === 0x6) {
        // 双字节
        // 110xxxxx10xxxxxx
        const code2 = str.charCodeAt(++i)
        const byte1 = (code & 0x1F) << 6
        const byte2 = code2 & 0x3F
        const utf16 = byte1 | byte2
        res.push(String.fromCharCode(utf16))
      } else if (((code >> 4) & 0xFF) === 0xE) {
        // 三字节
        // 1110xxxx10xxxxxx10xxxxxx
        const code2 = str.charCodeAt(++i)
        const code3 = str.charCodeAt(++i)
        const byte1 = (code << 4) | ((code2 >> 2) & 0x0F)
        const byte2 = ((code2 & 0x03) << 6) | (code3 & 0x3F)
        const utf16 = ((byte1 & 0x00FF) << 8) | byte2
        res.push(String.fromCharCode(utf16))
      } else if (((code >> 3) & 0xFF) === 0x1E) {
        // 四字节
        // 11110xxx10xxxxxx10xxxxxx10xxxxxx
      } else if (((code >> 2) & 0xFF) === 0x3E) {
        // 五字节
        // 111110xx10xxxxxx10xxxxxx10xxxxxx10xxxxxx
      } else /** if(((code>>1)&0xFF)==0x7E) */{
        // 六字节
        // 1111110x10xxxxxx10xxxxxx10xxxxxx10xxxxxx10xxxxxx
      }
    }

    return res.join('')
  },
  encode: function (str) {
    if (!str) {
      return ''
    }
    const utf8 = this.UTF16ToUTF8(str)// 转成UTF8
    let i = 0// 遍历索引
    const len = utf8.length
    const res = []
    while (i < len) {
      const c1 = utf8.charCodeAt(i++) & 0xFF
      res.push(this.table[c1 >> 2])
      // 需要补2个=
      if (i === len) {
        res.push(this.table[(c1 & 0x3) << 4])
        res.push('==')
        break
      }
      const c2 = utf8.charCodeAt(i++)
      // 需要补1个=
      if (i === len) {
        res.push(this.table[((c1 & 0x3) << 4) | ((c2 >> 4) & 0x0F)])
        res.push(this.table[(c2 & 0x0F) << 2])
        res.push('=')
        break
      }
      const c3 = utf8.charCodeAt(i++)
      res.push(this.table[((c1 & 0x3) << 4) | ((c2 >> 4) & 0x0F)])
      res.push(this.table[((c2 & 0x0F) << 2) | ((c3 & 0xC0) >> 6)])
      res.push(this.table[c3 & 0x3F])
    }

    return res.join('')
  },
  decode: function (str) {
    if (!str) {
      return ''
    }

    const len = str.length
    let i = 0
    const res = []

    while (i < len) {
      const code1 = this.table.indexOf(str.charAt(i++))
      const code2 = this.table.indexOf(str.charAt(i++))
      const code3 = this.table.indexOf(str.charAt(i++))
      const code4 = this.table.indexOf(str.charAt(i++))

      const c1 = (code1 << 2) | (code2 >> 4)
      const c2 = ((code2 & 0xF) << 4) | (code3 >> 2)
      const c3 = ((code3 & 0x3) << 6) | code4

      res.push(String.fromCharCode(c1))

      if (code3 !== 64) {
        res.push(String.fromCharCode(c2))
      }
      if (code4 !== 64) {
        res.push(String.fromCharCode(c3))
      }
    }

    return this.UTF8ToUTF16(res.join(''))
  }
}

// 转16进制字符
export const strToHexCharCode16 = {
  /* stringToHex (str) {
      var val = ''
      for (var i = 0; i < str.length; i++) {
        if (val === '') { val = str.charCodeAt(i).toString(16) } else { val += ',' + str.charCodeAt(i).toString(16) }
      }
      return val
    }, */
  strToHexCharCode (str) {
    if (str === '') { return '' }
    var hexCharCode = []
    hexCharCode.push('0x')
    for (var i = 0; i < str.length; i++) {
      hexCharCode.push((str.charCodeAt(i)).toString(16))
    }
    return hexCharCode.join('')
  }
}
// JSEncrypt 加密解密
export const jsEncrypt = {
  // 加密
  encryptPublic (value, publicKey) {
    // 使用公钥加密，default_key_size可为512，1024，2048等
    // console.log('加密----------', value, publicKey)
    const encrypt = new JSEncrypt()
    encrypt.setPublicKey(publicKey)
    const encrypted = encrypt.encrypt(value)
    // console.log('加密得到的结果----------', encrypted)
    return encrypted
  },
  // 解密
  decryptPrivate (value, privateKey) {
    // console.log('解密------------', value, privateKey)
    const encrypt = new JSEncrypt()
    encrypt.setPrivateKey(privateKey) // 设置私钥
    const decrypt = encrypt.decrypt(value) // 解密
    // console.log('解密得到的结果------------', decrypt)
    return decrypt
  }
}

export function debounce(fn, delay = 300) {
	return function(args) {
		let that = this;
		let _args = args;
		clearTimeout(fn.id);
		fn.id = setTimeout(() => {
			fn.call(that, _args)
		}, delay)
	}
}
